import { render, staticRenderFns } from "./OrganisationAdmin.vue?vue&type=template&id=3e46c4c8&"
import script from "./OrganisationAdmin.vue?vue&type=script&lang=ts&"
export * from "./OrganisationAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports